// extracted by mini-css-extract-plugin
export default {"btn":"skillsbtn_btn__v+EOu","icon":"skillsbtn_icon__qsgXw"};